import {Box,Flex,Grid,GridItem,Image,Input,InputGroup,InputLeftElement,Select,Table,TableContainer,Tbody,Td,Text,Th,Thead,Tr,Drawer,DrawerOverlay,DrawerContent,DrawerCloseButton,DrawerHeader,DrawerBody,FormControl,FormLabel,Button, Center, Spinner,} from "@chakra-ui/react";
import MyDiv from "./industryType.style";
import { ChevronDownIcon, Search2Icon } from "@chakra-ui/icons";
import { AlertCard, CustomButton, CustomToast,ActionEditIcon, CustomTable } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IIndustry } from "./model";
import { Column } from "../../../../components/CustomTable/customTable";

const Header = [
  { id: 1, head: "S. No" },
  { id: 2, head: "Industry Type" },
  { id: 3, head: "Status" },
  { id: 4, head: "Actions" },
];

const IndustryType = () => {
  const [industryType, setIndustryType] = useState<IIndustry[]>([]);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [DrawerOpen, setDrawerOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [pendingStatus, setPendingStatus] = useState<boolean | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentIndustry, setCurrentIndustry] = useState({id:0 , name: "", status: true,});
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [statusChangeSource, setStatusChangeSource] = useState<"table" | "drawer" | null>(null);

  useEffect(() => {
    loadIndustryType();
  }, []);

  const loadIndustryType = async () => {
      const response = await fetchApi<IIndustry[]>("Hrlense_IndustryType", "GET");
      if (response) setIndustryType(response);
  };

  const handleStatusChange = (id: number,  newStatus: boolean) => {
    setSelectedId(id);
    setPendingStatus(newStatus);
    setStatusChangeSource("table");
    setAlertOpen(true);
  };

  const handleDrawerStatusChange = (newStatus:boolean) => {
    setPendingStatus(newStatus);
    setStatusChangeSource("drawer");
    setAlertOpen(true);
  };
  
  const handleConfirmStatusChange = async () => {
    if (selectedId !== null && pendingStatus !== null) {
      const scoreId = statusChangeSource === "table" ? selectedId : currentIndustry.id;

        const response = await fetchApi( `Hrlense_IndustryType/toggleStatus/${scoreId}`,"PUT", { id: scoreId, status: pendingStatus }, null, "Industry Type updated successfully");
        if (response) {
          if (statusChangeSource === "table") {
            setIndustryType((prev) => prev.map((industryType) => industryType.id === selectedId ? { ...industryType, status: pendingStatus } : industryType));
          } else {
            setCurrentIndustry((prev) => ({ ...prev, status: pendingStatus }));
          }
        }
    }
    setAlertOpen(false);
  };

  const handleAddNewIndustryType = () => {
    setIsEditMode(false);
    setCurrentIndustry({ id:0, name: "",  status: true,});
    setDrawerOpen(true);
  };

  const handleEditIndustryType = (industry: IIndustry) => {
    setIsEditMode(true);
    setSelectedId(industry.id);
    setCurrentIndustry(industry);
    setDrawerOpen(true);
  };

  const handleInputChange = (e: any) => {
  const { name, value } = e.target;
  if (!/^[A-Za-z\s]*$/.test(value)) {
    return;
  }
  setCurrentIndustry(prev => ({
    ...prev,
    [name]: value
  }));
 };


  const handleSubmit = async () => {
    if (!currentIndustry.name.trim()) {
    addToast({ message: "Please enter Industry Type", status: "warning" });
    return;
  }
    if (isEditMode) {
      const response = await fetchApi( `Hrlense_IndustryType/${currentIndustry.id}`, 'PUT',{ id: currentIndustry.id, name: currentIndustry.name, status: currentIndustry.status}, null, "Industry Type updated successfully");
        if (response) setIndustryType((prev) => prev.map((industryType) => (industryType.id === selectedId ? currentIndustry : industryType)));
      } else {
        const response = await fetchApi<IIndustry>( 'Hrlense_IndustryType', 'POST', { name: currentIndustry.name, status: currentIndustry.status}, null, "Industry Type added successfully");

        if (response) setIndustryType((prev) => [...prev, response]);
      }
      setDrawerOpen(false);
    };

    const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");
  
  return (
    <MyDiv>
      <Box position="relative" minH="300px">
      {loading ? (
        <Center position="absolute" top={0} left={0} right={0} bottom={0}>
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
        </Center>) : (
      <>
      <Flex className="page_heading flex_header">
        <Text className="font-poppins text_semibold text_3xl">Industry Type</Text>
        <Flex gap={2}>
          <InputGroup width="197px" height="37px">
            <InputLeftElement pointerEvents="none">
              <Search2Icon color="rgba(102, 112, 133, 1)" />
            </InputLeftElement>
            <Input  type="text" className="font-poppins text_regular text_md"  placeholder="Search Industry Name...."  maxW="500px"/>
          </InputGroup>
          <CustomButton title="Add New Industry Type" className=" btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewIndustryType}/>
        </Flex>
      </Flex>
      <Grid className="grid_container">
        <GridItem colSpan={12}>
          <CustomTable value={industryType} >
            <Column header="S. No" body={(_, index) => index + 1} />
            <Column header="Industry Type" field="name" />
          
            <Column
              header="Status"
              body={(row: any) => (
                <Select
                  value={row.status ? "true" : "false"}
                  onChange={(e) =>
                    handleStatusChange(row.id, e.target.value === "true")
                  }
                  width="120px"
                  height="32px"
                  icon={<ChevronDownIcon />}
                  borderRadius="4px"
                  color={getStatusColor(row.status)}
                  className="font-poppins text_medium text_xsm"
                >
                  <option value="true" style={{ color: "#38A169" }}>Active</option>
                  <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                </Select>
              )}
            />
          
            <Column
              header="Actions"
              body={(row: any) => (
                <Flex justify="center">
                  <ActionEditIcon onClick={() => handleEditIndustryType(row)} />
                </Flex>
              )}
            />
          </CustomTable>

        </GridItem>
      </Grid>
      <AlertCard isOpen={AlertOpen} onClose={() => setAlertOpen(false)} onConfirm={handleConfirmStatusChange} />
      <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit Industry Type" : "Add New Industry Type"}</DrawerHeader>
          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%" >
            <Box py={4}>
              <FormControl mb={4} isRequired>
                <FormLabel>Industry Type</FormLabel>
                <Input name="name" value={currentIndustry.name} onChange={handleInputChange} placeholder="Enter Industry Type"/>
              </FormControl>
              <FormControl mb={4}>
                <FormLabel>Status</FormLabel>
                <Select w="120px" value={currentIndustry.status ? "true" : "false"} onChange={(e) => handleDrawerStatusChange(e.target.value === "true")} color={getStatusColor(currentIndustry.status)}>
                  <option value="true" style={{ color: "#38A169" }}> Active</option>
                  <option value="false" style={{ color: "#E53E3E" }}>Inactive</option>
                </Select>
              </FormControl>
            </Box>
            <Flex justify="flex-end" mt={4} gap={2}>
              <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}>Cancel</Button>
              <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }}>{isEditMode ? "Update Industry Type" : "Add Industry Type"}</Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>     
      </>)}
    </Box>
    </MyDiv>
  );
};

export default IndustryType;
